import React from "react";

// Click any tx hash anywhere → switch to Transactions mode and load it.
export const TxNavContext = React.createContext(null);
export const useTxNav = () => React.useContext(TxNavContext);

// Click any address anywhere → switch to Addresses mode and load it.
export const AddrNavContext = React.createContext(null);
export const usePickAddress = () => React.useContext(AddrNavContext);

// Click a block number anywhere → switch to Blocks mode and load it.
export const BlockNavContext = React.createContext(null);
export const useBlockNav = () => React.useContext(BlockNavContext);

// Click an asset badge anywhere → switch to Assets mode and load that token.
export const AssetNavContext = React.createContext(null);
export const usePickAsset = () => React.useContext(AssetNavContext);
